import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
  faGlobe, faKey, faSortDown, faSortUp, faSitemap, faBriefcase,
  faChalkboardTeacher, faSignOutAlt, faLock, faPlus, faEdit, faTrashAlt,
  faInfoCircle, faUser, faCheckCircle, faTimes, faSpinner, faExclamationTriangle,
  faChevronDown, faChevronRight, faMinus, faExternalLinkAlt, fas
} from '@fortawesome/free-solid-svg-icons';
import { faEyeSlash, faEye, faEnvelope, faIdCard, faSave, far } from '@fortawesome/free-regular-svg-icons';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  declarations: [],
  exports: [
    FontAwesomeModule
  ]
})
export class CustomFontAwesomeModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(far, fas);
    library.addIcons(
      faSpinner,
      faPlus,
      faEdit,
      faTrashAlt,
      faMinus,
      // faQuestionCircle,
      faCheckCircle,
      faExclamationTriangle,
      faInfoCircle,
      // faTimesCircle,
      faExternalLinkAlt,
      faUser,
      faEye,
      faEyeSlash,
      // faEllipsisH,
      faGlobe,
      faEnvelope,
      faKey,
      // faRandom,
      faSortDown,
      faSortUp,
      faSitemap,
      faBriefcase,
      faChalkboardTeacher,
      faSignOutAlt,
      faIdCard,
      faLock,
      faSave,
      faTimes,
      faChevronDown,
      faChevronRight
    );

  }
}
